import React from 'react';

import { IconButton } from '@eika/button';
import { IconTypes } from '@eika/icon';

import { Piwik, SiteCoreDictionary } from '../types';

import './ConvertRateInfoLine.scss';

interface ConvertRateInfoLineProps {
    onClickMoreInfo: () => void;
    dictionary: SiteCoreDictionary;
    piwik: Piwik | undefined;
}

const ConvertRateInfoLine = ({ onClickMoreInfo, dictionary, piwik }: ConvertRateInfoLineProps) => {
    const { visaCalculatorDetailsHeaderMobile } = dictionary;

    return (
        <div className="detailed-info-line">
            <span>{visaCalculatorDetailsHeaderMobile}</span>
            <IconButton
                screenReaderText={visaCalculatorDetailsHeaderMobile}
                icon={IconTypes.INFO_24}
                data-track-id={piwik?.visaCalculator?.visaExchangeCalculatorReadMoreCardInfoIconButton?.dataTrackId}
                data-track-linkname={
                    piwik?.visaCalculator?.visaExchangeCalculatorReadMoreCardInfoIconButton?.dataTrackLinkname
                }
                id={piwik?.visaCalculator?.visaExchangeCalculatorReadMoreCardInfoIconButton?.dataTrackId}
                onClick={() => onClickMoreInfo()}
            />
        </div>
    );
};

export default ConvertRateInfoLine;
